// import "./BasketballCourt.css";

import runningTrack from "../../data/runningTrackData";

import ServiceHero from "../../components/ServiceHero/ServiceHero";
import ServiceOverview from "../../components/ServiceOverview/ServiceOverview";
import ServiceBenefits from "../../components/ServiceBenefits/ServiceBenefits";
import ConstructionProcess from "../../components/ConstructionProcess/ConstructionProcess";
import TechnicalSpecs from "../../components/TechnicalSpecs/TechnicalSpecs";
import ServiceGallery from "../../components/ServiceGallery/ServiceGallery";
import WhyChooseService from "../../components/WhyChooseService/WhyChooseService";
import ServiceFAQ from "../../components/ServiceFAQ/ServiceFAQ";
import RelatedServices from "../../components/RelatedServices/RelatedServices";
import ServiceCTA from "../../components/ServiceCTA/ServiceCTA";

const RunningTrack = () => {
  return (
    <>
      <ServiceHero data={runningTrack} />

      <ServiceOverview data={runningTrack} />

      <ServiceBenefits data={runningTrack} />

      <ConstructionProcess />

      <TechnicalSpecs data={runningTrack} />

      <ServiceGallery data={runningTrack} />

      <WhyChooseService data={runningTrack} />

      <ServiceFAQ faqs={runningTrack.faqs} />

      <RelatedServices data={runningTrack} />

      <ServiceCTA data={runningTrack} />
    </>
  );
};

export default RunningTrack;
